import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
});

// Guard de Política de Privacidade (LGPD): se o backend bloquear o acesso de um
// candidato que ainda não aceitou a política, redireciona para a tela de aceite.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isPrivacyBlock =
      error?.response?.status === 403 &&
      error?.response?.data?.error === "privacy_policy_required";

    if (
      isPrivacyBlock &&
      !window.location.pathname.includes("/candidate/accept-privacy-policy")
    ) {
      window.location.href = "/candidate/accept-privacy-policy";
    }

    return Promise.reject(error);
  }
);

export default api;
